// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2Tnd3","header":"ClearentDisclaimer_header__1lriM","inner":"ClearentDisclaimer_inner__5hUCr"};